import React from "react";
import Logo from "@/components/site/Logo";

const links = [
  { label: "Portfolio", href: "#projects" },
  { label: "Services", href: "#services" },
  { label: "Team", href: "#team" },
  { label: "Contact", href: "#contact" },
];

export const Footer = () => {
  const go = (e, href) => {
    e.preventDefault();
    document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer
      data-testid="site-footer"
      className="py-10 md:py-12 border-t"
      style={{
        backgroundColor: "#1a2330",
        color: "rgba(244,241,235,0.82)",
        borderColor: "rgba(244,241,235,0.12)",
      }}
    >
      <div className="container-editorial flex flex-col md:flex-row items-center justify-between gap-6">
        <Logo />
        <nav className="flex items-center gap-7" aria-label="Footer">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={(e) => go(e, l.href)}
              data-testid={`footer-link-${l.label.toLowerCase()}`}
              className="font-body text-xs tracking-[0.18em] uppercase hover:opacity-100 opacity-80 transition-opacity"
            >
              {l.label}
            </a>
          ))}
        </nav>
        <p className="font-body text-xs tracking-[0.12em] opacity-70">
          © 2026 Studio Brehaut
        </p>
      </div>
    </footer>
  );
};

export default Footer;
